import { useEffect, useRef } from 'react';
import { clearQueuedSecureCardViewerToken, exposeSecureCardViewerBootstrap, flushQueuedSecureCardViewerToken, } from '../utils/initSecureCardViewer';
import { loadSwapSecureCardViewerScript } from '../utils/loadSwapSecureCardViewerScript';
import { postSecureCardViewerContentHeight, postSecureCardViewerMessage } from '../utils/postSecureCardViewerMessage';
import { resolveSwapSecureCardViewerScriptUrl } from '../utils/resolveSwapSecureCardViewerScriptUrl';
export function useSecureCardViewerBootstrap(contentRef) {
    const readyPostedRef = useRef(false);
    useEffect(() => {
        let cancelled = false;
        let contentSizeObserver;
        let renderedFieldsObserver;
        const reportHeight = () => {
            postSecureCardViewerContentHeight(contentRef.current);
        };
        const observeRenderedContent = () => {
            const contentElement = contentRef.current;
            if (!contentElement) {
                return;
            }
            if (typeof ResizeObserver !== 'undefined') {
                contentSizeObserver = new ResizeObserver(reportHeight);
                contentSizeObserver.observe(contentElement);
            }
            if (typeof MutationObserver !== 'undefined') {
                renderedFieldsObserver = new MutationObserver(reportHeight);
                renderedFieldsObserver.observe(contentElement, {
                    characterData: true,
                    childList: true,
                    subtree: true,
                });
            }
        };
        const handlePageError = () => {
            postSecureCardViewerMessage({ message: 'error', reason: 'page' });
        };
        globalThis.addEventListener('error', handlePageError);
        exposeSecureCardViewerBootstrap();
        loadSwapSecureCardViewerScript(resolveSwapSecureCardViewerScriptUrl())
            .then(() => {
            if (cancelled) {
                return;
            }
            if (!readyPostedRef.current) {
                readyPostedRef.current = true;
                postSecureCardViewerMessage({ message: 'ready' });
            }
            flushQueuedSecureCardViewerToken();
            reportHeight();
            observeRenderedContent();
        })
            .catch(() => {
            if (cancelled) {
                return;
            }
            postSecureCardViewerMessage({ message: 'error', reason: 'script' });
        });
        return () => {
            cancelled = true;
            globalThis.removeEventListener('error', handlePageError);
            contentSizeObserver?.disconnect();
            renderedFieldsObserver?.disconnect();
            clearQueuedSecureCardViewerToken();
            delete globalThis.__initSecureCardViewer;
        };
    }, [contentRef]);
}
